var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group full-width",attrs:{"role":"group"}},_vm._l((_vm.optionsArraySorted),function(item){return _c('button',{staticClass:"btn",class:{
            'btn-primary': item.key === _vm.selectedKey,
            'btn-default': item.key !== _vm.selectedKey,
          },attrs:{"type":"button"},on:{"click":function($event){return _vm.selectValue(item.key)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }